module.exports = __webpack_public_path__ + "img/maquina.f0053977.jpeg";